import checkUserDataDictionary from '../../ru/check-user-data/check-user-data.dic.json';

export const checkUserDataNS = {
  CHECK_USER_DATA: checkUserDataDictionary,
};

export const checkUserDataNamespaces = ['CHECK_USER_DATA'];
